<template>
    <pop-up class="base-modal" v-model="showDialog" get-container="body" :close-on-click-overlay="closeOnClickOverlay">
        <div class="content">
            <img class="avator" src="./img/avator.png" alt="" />
            <div class="title">您是否在支付已完成认证</div>
            <div class="btn primary" @click="handleFinish">已完成认证</div>
            <div class="btn" @click="handleUnfinished">未完成</div>
        </div>
    </pop-up>
</template>

<script>
import 'vant/lib/popup/style';
import Popup from 'vant/lib/popup';

export default {
    name: 'CheckFinish',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        closeOnClickOverlay: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        'pop-up': Popup,
    },
    data() {
        return {};
    },
    computed: {
        showDialog: {
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit('input', newVal);
            },
        },
    },
    methods: {
        handleClose() {
            this.showDialog = false;
        },
        handleFinish() {
            this.$emit('cert-finished');
        },
        handleUnfinished() {
            this.$emit('cert-unfinished');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~root/blackcard/assets/styles/mixin.scss';
.base-modal {
    border-radius: 0.16rem;
    overflow: hidden;
    .content {
        width: 6.4rem;
        padding: 0.4rem 0.4rem 0.5rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .avator {
            width: 1.14rem;
            height: 1.14rem;
            display: block;
        }
        .title {
            height: 0.48rem;
            font-size: 0.32rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 0.48rem;
            margin: 0.2rem 0 0.4rem;
        }
    }
    .btn {
        width: 5.3rem;
        height: 0.9rem;
        border-radius: 0.45rem;
        line-height: 0.9rem;
        text-align: center;
        background: #ffffff;
        @include border-1px(rgba(102, 102, 102, 1), 1rem);
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #252220;

        &.primary {
            margin-bottom: 0.3rem;
            background: linear-gradient(90deg, #4f4f4f 0%, #252220 100%);
            font-size: 0.28rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fde2c7;
        }
    }
    &-inner {
        width: 6.3rem;
    }
}
</style>
